import { Component,Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Invalidations, RecognitionErrors } from '../face-recognition-modal/face-recognition-modal.component';
import { AmplitudeService } from 'src/app/services/amplitude.service';
import { UserService } from 'src/app/services/user.service';
import { AmplitudeEvent, IncompleteRegistration, Platform, ScanType, VisitType } from 'src/app/interface/amplitude.interface';
import { FormGroup } from '@angular/forms';

enum ErrorMessagesCode{
  RecognitionFailed = "faceRecognition.errors.recognitionFailed",
  PermissionsDenied = "faceRecognition.errors.permissionsDenied",
  CameraUndetected  = "faceRecognition.errors.cameraUndetected"
}

enum ErrorTitleMessagesCode{
  stopped = "faceRecognition.errors.stopped",
  incomplete = "faceRecognition.errors.incomplete"
}

@Component({
  selector: 'app-error-mannagment',
  templateUrl: './error-mannagment.component.html',
  styleUrls: ['./error-mannagment.component.scss']
})

export class ErrorMannagmentComponent implements OnInit {
public recognitionErrors = RecognitionErrors;
@Input() errorType:RecognitionErrors;
@Input() invalidations :{error:Invalidations, value:any}[];
@Input() formGuest: FormGroup;
@Output() resetRegistration: EventEmitter<void> = new EventEmitter();
@Output() cancelRegistration: EventEmitter<void> = new EventEmitter();
public errorMessage:ErrorMessagesCode | undefined;
public errorsList: string[] = [];
public errorTitleMessage:ErrorTitleMessagesCode | undefined;


  constructor(
    private amplitudeService: AmplitudeService,
    private userService: UserService
  ){
    
  }

  ngOnInit(){
    this.setErrorMessage(this.errorType);
  }

  cancel(){
    this.amplitudeService.sendToAmplitude({
      event_type: AmplitudeEvent.incompleteRegistration,
      user_id: this.userService.getUser().id,
      event_properties: {
        'Tipo de Escaneo': ScanType.visit,
        'Tipo de Visita': this.formGuest?.getRawValue().personInvitationType?.value ?? null,
        'Plataforma':Platform.dashboardVigilant,
        'Continue' :false
      } as IncompleteRegistration
    });
    this.cancelRegistration.emit();
  }

  tryAgain(){
    this.amplitudeService.sendToAmplitude({
      event_type: AmplitudeEvent.incompleteRegistration,
      user_id: this.userService.getUser().id,
      event_properties: {
        'Tipo de Escaneo': ScanType.visit,
        'Tipo de Visita': this.formGuest?.getRawValue().personInvitationType?.value ?? null,
        'Plataforma':Platform.dashboardVigilant,
        'Continue' :true
      } as IncompleteRegistration
    });
    this.resetRegistration.emit();
  }

  setErrorMessage(errorType:RecognitionErrors = RecognitionErrors.Recognition):void{
    switch (errorType) {
      case RecognitionErrors.Recognition:
        this.errorMessage = ErrorMessagesCode.RecognitionFailed;
        this.errorTitleMessage = ErrorTitleMessagesCode.incomplete;
      break;
      case RecognitionErrors.Permissions:
        this.errorMessage = ErrorMessagesCode.PermissionsDenied;
        this.errorTitleMessage = ErrorTitleMessagesCode.stopped;
      break;
      case RecognitionErrors.Camera:
        this.errorMessage = ErrorMessagesCode.CameraUndetected;
        this.errorTitleMessage = ErrorTitleMessagesCode.stopped;
      break;
      default:
        this.errorMessage = ErrorMessagesCode.RecognitionFailed;
        this.errorTitleMessage = ErrorTitleMessagesCode.incomplete;
        this.listErrors();
      break;
    }
  }

  listErrors(){
    this.invalidations?.forEach((inv)=>{
      this.errorsList.push(`faceRecognition.errors.invalidations.${inv.error}`);
    });
  }
}
